/**
 * Standard page heading for PDF thumbs / lists.
 * When {@link pageName} is present and not just the page number: `Page 1 - Name`.
 */
export const formatPdfPageHeading = (
  pageIndex: number,
  pageName?: string,
): string => {
  const pageNumber = pageIndex + 1;
  const name = pageName?.trim();
  if (!name || name === String(pageNumber)) return `Page ${pageNumber}`;
  return `Page ${pageNumber} - ${name}`;
};

/**
 * Compact mapping line for the Design PDF panel: `Page 1 → Storey 1 – 3`.
 */
export const formatPdfPageToStoreysLabel = (
  pageIndex: number,
  fromLevel: number,
  toLevel: number,
): string => {
  const page = `Page ${pageIndex + 1}`;
  if (fromLevel === toLevel) return `${page} → Storey ${fromLevel}`;
  return `${page} → Storey ${fromLevel} – ${toLevel}`;
};
